$(document).ready(function(){
  $(document).on("click", ".agree", function(){
    	$(".error_msg").hide();
    	var year = $("#dob__year").val();
        var month = $("#dob__month").val();
        var date = $("#dob__day").val();
		if(getAge(year+"/"+month+"/"+date) > 18){
          localStorage.setItem('age', 'verified');
          $("#preview_img").hide();
        }
        else{
          $(".error_msg").show();
        }
  });
  var age = localStorage.getItem('age');
  if(age == "verified"){
    $("#preview_img").hide();
  }else{
    $("#preview_img").show();
  }
});


function getAge(dateString) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}